import protoRoot from "../proto-root";

const name = "playLullabyRpcResponse";

function create({ result }) {
  const PlayLullabyRpcResponse = protoRoot.lookupType(
    "comm.PlayLullabyRpcResponse"
  );
  const Result = PlayLullabyRpcResponse.lookupEnum("Result");

  const response = PlayLullabyRpcResponse.create({
    result: Result.values[result]
  });

  return { payload: response, name };
}

export default {
  create,
  name
};

// message PlayLullabyRpcResponse {
//   enum Result {
//       PREPARING = 0;
//       NOT_AVAILABLE = 1;
//   }
//   Result result = 1;
// }
